import { render, staticRenderFns } from "./Cibi.vue?vue&type=template&id=3963f6b4&scoped=true"
import script from "./Cibi.vue?vue&type=script&lang=js"
export * from "./Cibi.vue?vue&type=script&lang=js"
import style0 from "./Cibi.vue?vue&type=style&index=0&id=3963f6b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3963f6b4",
  null
  
)

export default component.exports